const RECENTLY_SUBMITTED_QUICKFUND_REQUEST = 99;
export enum QuickFundMessageEnum {
    Learn,
    /** Message that the credit application is not qualify for QuickFund due to its status. */
    Due,
    /** Message that credit application is eligible for QuickFund. */
    EligibleMessage,
    /** Message that credit application is eligible for QuickFund with a valid contract. */
    EligibleMessageWithContract,
    /** Message that QuickFund option is not available since the credit application was decisioned more than 30 days ago. */
    Option,
    /** Message that QuickFund is not currently available. */
    TryAgainLater,
    /** Message that credit application is not eligible for QuickFund since the funding package has received by VCI. */
    NotEligibleSendToVCI,
    /** Message that QuickFund option is not eligible since the credit application status does not qualify. */
    DoesNotQualifyMessage,
    /** Message that Application has been already quick funded. */
    AlreadyQuickFunded,
    /** Other represents a message for conditions not specified. */
    Other,
    /** Message that credit application is not eligible for QuickFund since no validated contract has been received. */
    NotEligibleDueToMissingOrFailedContractValidation,
    /** Default State for recently submitted QuickFund requests. */
    RecentlySubmitted = RECENTLY_SUBMITTED_QUICKFUND_REQUEST,
}
